import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError } from 'rxjs/operators';
import { ConfigDto, DynamicCard, DynamicField, DynamicLink, FormDataDto, SelfRegCardDto, ServiceSelectionDto } from 'src/app/services/dtos';
import { HttpSelfRegCardService } from 'src/app/services/http-selfreg-card.service';
import { HttpSubmissionService } from 'src/app/services/http-submission.service';
import { ToastService } from 'src/app/services/toast.service';

class DynamicFieldWithImage {
	field: DynamicField;
	image: any;
}

@Component({
	selector: 'app-selfreg-card',
	templateUrl: './selfreg-card.component.html',
	styleUrls: ['./selfreg-card.component.scss']
})
export class SelfRegCardComponent implements OnInit {

	axonId: number;
	pin: string;

	selfRegCardData: SelfRegCardDto;

	constructor(
		private toast: ToastService, 
		private httpSelfRegService: HttpSelfRegCardService, 
		private spinner: NgxSpinnerService,
		private route: ActivatedRoute,
		private translateService: TranslateService) { }

	ngOnInit(): void {
		this.axonId = this.route.snapshot.params['axonId'];
		this.pin = this.route.snapshot.params['pin'];
		console.log('AxonId: ' + this.axonId + ' - PIN: ' + this.pin);

		this.spinner.show();
		this.httpSelfRegService.getSelfRegCardData(this.axonId, this.pin)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error', error);
				
				this.toast.show('Failed fetching self registration data: ' + error.error.message);
				throw error;
			})
		)
		.subscribe(
			data => {
				console.log('Got data from server: ', data);
				this.selfRegCardData = data;
				this.selfRegCardData.image = 'data:image/jpeg;base64,' + this.selfRegCardData.image;
				this.selfRegCardData.qrImage ='data:image/jpeg;base64,' + this.selfRegCardData.qrImage;

				this.spinner.hide();
				console.log(this.selfRegCardData);
			}
		);
	}
}
